module.exports = __webpack_public_path__ + "static/media/logo1.f4973145.png";